import Loading from "./Loading";
import { getApiErrorMessage, getSupportEmailHref, isServerIssueError } from "@utils/apiErrorUtils";

export default function DataStateHandler({
  isLoading,
  error,
  isEmpty,
  loadingMessage = "Loading...",
  emptyMessage = "No data available",
  title,
  showLoadingSpinner = false,
  children,
}) {
  if (isLoading) {
    if (showLoadingSpinner) {
      return (
        <div className="flex items-center justify-center py-12">
          <Loading size="md" text={loadingMessage} />
        </div>
      );
    }
    return <div className="p-8 text-center text-palette-gray-secondary">{loadingMessage}</div>;
  }

  if (error) {
    const status = error.response?.status;
    const message = getApiErrorMessage(error);
    const supportEmailHref = getSupportEmailHref(error);

    return (
      <div className="p-8 text-center text-palette-red-label">
        {status === 400 ? (
          <>
            <div className="font-semibold mb-2">Bad Request</div>
            <div className="text-sm">{message}</div>
          </>
        ) : status === 401 ? (
          <>
            <div className="font-semibold mb-2">Unauthorized</div>
            <div className="text-sm">{message}</div>
          </>
        ) : status === 403 ? (
          <>
            <div className="font-semibold mb-2">Access Denied</div>
            <div className="text-sm">{message}</div>
          </>
        ) : status === 404 ? (
          <>
            <div className="font-semibold mb-2">Not Found</div>
            <div className="text-sm">{message}</div>
          </>
        ) : status === 429 ? (
          <>
            <div className="font-semibold mb-2">Too Many Requests</div>
            <div className="text-sm">{message}</div>
          </>
        ) : status === 500 ? (
          <>
            <div className="font-semibold mb-2">Server Error</div>
            <div className="text-sm">{message}</div>
          </>
        ) : status === 503 ? (
          <>
            <div className="font-semibold mb-2">Service Unavailable</div>
            <div className="text-sm">{message}</div>
          </>
        ) : (
          <>
            <div className="font-semibold mb-2">Error</div>
            <div className="text-sm">{message}</div>
          </>
        )}
        {isServerIssueError(error) && supportEmailHref ? (
          <div className="mt-4">
            <a
              href={supportEmailHref}
              className="inline-flex items-center rounded-md border border-palette-red-ring bg-white px-3 py-2 text-sm font-medium text-palette-red-heading hover:bg-palette-red-soft"
            >
              Contact Dev Team
            </a>
          </div>
        ) : null}
      </div>
    );
  }

  if (isEmpty) {
    return <div className="p-8 text-center text-palette-gray-secondary">{emptyMessage}</div>;
  }

  return children;
}
